module.exports = __webpack_public_path__ + "static/media/037.85b78583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/037.jpg
// module id = 383
// module chunks = 0